import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import UIAssetKeys from '../UIAssetKeys';

export default class LightRays extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.cont1 = null;
    this.cont2 = null;

    this.lights = [];
    this.counter = 0;
    this.adjX = 0;
    this.adjA = 0;
    this.randA = 0;

    this.lightTween = null;
    this.lightTween2 = null;

    this.setup();
  }

  setup () {
    this.createLights();
  }

  createLights() {
    this.cont1 = this.scene.add.container();
    this.cont2 = this.scene.add.container();

    let adj;
    if (gameData.config.level === 1 || gameData.config.level === 2) {
      adj = 5;
      this.adjX = 0;
      this.adjA = 0;
    }
    else if (gameData.config.level === 3) {
      adj = 2;
      this.adjX = 175;
      this.adjA = 25;
    }

    for (let i = 0; i < adj; i++) {
      let randAlpha;
      if (gameData.config.level === 1 || gameData.config.level === 2) {
        randAlpha = Phaser.Math.FloatBetween(.2, .7);
      }
      else if (gameData.config.level === 3) {
        randAlpha = Phaser.Math.FloatBetween(.2, .5);
      }

      const light = ABCyaPhaser.Images.addImage(-250 + this.adjX + (125 * i), -40, UIAssetKeys._3_Level_Assets_Common_LightRay, this.cont1).setOrigin(0.5, 0);
      light.angle = 40 - this.adjA - (20 * i);
      light.alpha = randAlpha;

      this.lights.push(light);
      this.moveLight(light);

      const light2 = ABCyaPhaser.Images.addImage(-200 + this.adjX + (100 * i), -40, UIAssetKeys._3_Level_Assets_Common_LightRay, this.cont2).setOrigin(0.5, 0);
      light2.angle = 20 - this.adjA - (10 * i);
      light2.alpha = randAlpha;

      this.lights.push(light2);
      this.moveLight(light2);

      if (i === 2) {
        light.x -= 20;
        light2.x += 20;
      }
    }

    this.cont1.x = this.scene.scale.width / 2;
    this.cont2.x = this.scene.scale.width / 2;
    this.cont1.angle = 5;
    this.cont2.angle = -5;
    this.cont1.alpha = 0;
    this.cont2.alpha = 0;

    ABCyaPhaser.Tweens.addTween(this.cont1, 2000, { alpha: 1 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.cont2, 2000, { alpha: 1 }, Phaser.Math.Easing.Linear);

    this.lightTween = ABCyaPhaser.Tweens.addTween(this.cont1, 5000, { angle: -5, repeat: -1, yoyo: true }, Phaser.Math.Easing.Sine.InOut);
    this.lightTween2 = ABCyaPhaser.Tweens.addTween(this.cont2, 3000, { angle: 5, repeat: -1, yoyo: true }, Phaser.Math.Easing.Sine.InOut);
  }

  /**
   * 
   * @param {Phaser.GameObjects.Image} light 
   */
  moveLight (light) {
    let randAlpha = 0;
    if (gameData.config.level === 1 || gameData.config.level === 2) {
      randAlpha = Phaser.Math.FloatBetween(.1, .75);
    }
    else if (gameData.config.level === 3) {
      randAlpha = Phaser.Math.FloatBetween(.1, .5);
    }
    const randDel = Phaser.Math.Between(0, 2000);
    const randTime = Phaser.Math.Between(1500, 3000);
    const randScale = Phaser.Math.FloatBetween(.66, 1);

    ABCyaPhaser.Tweens.addTween(light, randTime, { scaleX: randScale, delay: randDel }, Phaser.Math.Easing.Sine.InOut);
    ABCyaPhaser.Tweens.addTween(light, randTime, { alpha: randAlpha, delay: randDel }, Phaser.Math.Easing.Sine.InOut, () => {
      this.moveLight(light);
    });
  }

  cleanUp () {
    for (let l = 0; l < this.lights.length; l++) {
      this.scene.tweens.killTweensOf(this.lights[l]);
      this.lights[l].destroy();
    }

    this.scene.tweens.killTweensOf(this.cont1);
    this.scene.tweens.killTweensOf(this.cont2);
    this.lightTween?.stop();
    this.lightTween2?.stop();
    this.cont1.destroy();
    this.cont2.destroy();

    this.lights = null;
  }
}